// src/ui/components/Form.tsx
import { h, ComponentChildren } from "preact";

export interface FormProps<T extends Record<string, any>> {
    children: ComponentChildren;
    className?: string;
    handleSubmit: (e: Event) => Promise<void>;
}

export function Form<T extends Record<string, any>>({
    children,
    className,
    handleSubmit,
}: FormProps<T>) {
    return (
        <form onSubmit={handleSubmit} className={className}>
            {children}
        </form>
    );
}

interface FormFieldProps {
    label: string;
    name: string;
    type?: string;
    value: string;
    error?: string;
    onChange: (e: any) => void;
    required?: boolean;
}

export function FormField({
    label,
    name,
    type = "text",
    value,
    error,
    onChange,
    required,
}: FormFieldProps) {
    return (
        <div className="form-field">
            <label htmlFor={name}>{label}</label>
            <input
                id={name}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                required={required}
                className={error ? "error" : ""}
            />
            {error && <span className="error-message">{error}</span>}
        </div>
    );
}
